const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    margin: '16px 0',
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  card: {
    background: theme.palette.primary.white,
    border: `1px solid ${theme.palette.primary.borderColor}`,
    padding: 24,
  },
  titleHead: {
    fontSize: 20,
    fontWeight: 600,
  },

  containerPadding: {
    margin: '0px',
    width: '100%',
    padding: '12px !important',
    background: theme.palette.primary.white,
    border: `1px solid ${theme.palette.primary.borderColor}`,
  },
  title: {
    fontSize: '18px',
    fontWeight: '600',
    padding: '8px',
  },
  reviewTitle: {
    fontSize: '18px',
    fontWeight: '600',
    padding: '16px 0px',
  },
  fetchButton: {
    width: '100%',
  },
  detailsWrapper: {
    background: theme.palette.primary.white,
    [theme.breakpoints.up('sm')]: {
      padding: '20px',
    },
    border: '1px solid #D5D6D7',
  },
});
export default styles;
